import React, { useState, useEffect, Fragment, useMemo } from "react";
import "./App.css";
import HomePage from "./screens/home";
import TutorialsPage from "./screens/tutorials";
import ForgotPassword from "./screens/login/ForgotPassword";
import LoginPage from "./screens/login/Login";
import LandingPageV2 from "./screens/landingPage";
import UserManagement from "./screens/userManagement";
import GlobalSearch from "./screens/search";
import StudentAppConfig from "./screens/studentConfig";
import StudentData from "./screens/student";
import ReportsPage from "./screens/reportsPage";
import NotificationsPage from "./screens/notificationsPage";
import SmartPlans from "./screens/smartPlans";
import SmartPlanDetails from "./screens/smartPlans/SmartPlanDetails";
import DirectDebit from "./screens/directDebit";
import DirectDebitDetails from "./screens/directDebit/DirectDebitDetails";
import PayByLink from "./screens/payByLink";
import PayByLinkDetails from "./screens/payByLink/PayByLinkDetails";
import Pricing from "./screens/pricing";
import Layout from "./screens/layout";
import Remove from "./screens/remove";
import Products from "./screens/products";
import Categories from "screens/products/categories";
import ProductDetails from "./screens/products/details";
import CategoryDetails from "./screens/products/categories/details";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { NavigationContext } from "./NavigationContext";
import { ROUTES } from "./config/routes";
import { ADMIN_TYPE } from "./config/constants";

function App() {
  let role = localStorage.getItem("role");
  const [roleData, setRoleData] = useState(role);
  const navigate = useNavigate();

  useEffect(() => {
    setRoleData(role);
  }, [role]);

  const navigationHelpers = useMemo(
    () => ({
      navigateTo: (path) => navigate(path),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
    }),
    [navigate],
  );

  const hasAccess =
    roleData === ADMIN_TYPE.SUPER_ADMIN || roleData === ADMIN_TYPE.SALES_ADMIN;

  return (
    <NavigationContext.Provider value={navigationHelpers}>
      <Routes>
        <Route path={ROUTES.HOME} element={<HomePage />} />
        <Route path={ROUTES.TUTORIALS} element={<TutorialsPage />} />
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
        <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
        <Route path={ROUTES.REMOVE} element={<Remove />} />
        {hasAccess && (
          <Route
            path={ROUTES.MERCHANT_OUTLET}
            element={<Layout.GlobalLayout />}
          >
            <Route
              path={ROUTES.MAIN_LANDING_OUTLET}
              element={<LandingPageV2 />}
            />
            <Route path={ROUTES.SEARCH_OUTLET} element={<GlobalSearch />} />
          </Route>
        )}

        <Route
          path={ROUTES.MERCHANT_OUTLET}
          element={<Layout.MerchantLayout />}
        >
          <Route
            index
            path={ROUTES.STUDENT_DATA_OUTLET}
            element={<StudentData />}
          />
          {(roleData === ADMIN_TYPE.SUPER_ADMIN ||
            roleData === ADMIN_TYPE.SCHOOL_ADMIN) && (
            <>
              <Route
                index
                path={ROUTES.MARKETPLACE_OUTLET}
                element={<Products />}
              />
              <Route index path={ROUTES.CATEGORIES} element={<Categories />} />
              <Route
                path={ROUTES.CATEGORY_DETAILS_OUTLET}
                element={<CategoryDetails />}
              />
              <Route
                path={ROUTES.SMART_PLANS_OUTLET}
                element={<SmartPlans />}
              />
              <Route
                path={ROUTES.SMART_PLANS_DETAIL_OUTLET}
                element={<SmartPlanDetails />}
              />
              <Route
                path={ROUTES.DIRECT_DEBIT_OUTLET}
                element={<DirectDebit />}
              />
              <Route
                path={ROUTES.DIRECT_DEBIT_DETAIL_OUTLET}
                element={<DirectDebitDetails />}
              />
              <Route
                path={ROUTES.PAY_BY_LINK_OUTLET}
                element={<PayByLink />}
              />
              <Route
                path={ROUTES.PAY_BY_LINK_DETAIL_OUTLET}
                element={<PayByLinkDetails />}
              />
              <Route path={ROUTES.PRICING_OUTLET} element={<Pricing />} />
            </>
          )}

          <Route
            index
            path={ROUTES.MARKETPLACE_DETAILS_OUTLET}
            element={<ProductDetails />}
          />
          <Route path={ROUTES.REPORTS_OUTLET} element={<ReportsPage />} />
          {hasAccess && (
            <Fragment>
              <Route
                path={ROUTES.USER_MANAGEMENT_OUTLET}
                element={<UserManagement />}
              />
              <Route
                path={ROUTES.STUDENT_APP_CONFIG_OUTLET}
                element={<StudentAppConfig />}
              />
            </Fragment>
          )}
          <Route
            path={ROUTES.NOTIFICATIONS_OUTLET}
            element={<NotificationsPage />}
          />
          {!!roleData && (
            <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
          )}
        </Route>
      </Routes>
    </NavigationContext.Provider>
  );
}

export default App;
